import { trackAnalyticsEvent } from 'web-utils';

interface Action {
  type: string;
  attrs?: any;
  eventKey?: string;
}

type NextFunction = (action: Action) => void;

const analyticMiddleware = () => (next: NextFunction) => (action: Action) => {
  const { attrs, eventKey } = action;

  if (action.type !== 'GC_ANALYTICS' || !eventKey) {
    return next(action);
  }

  try {
    trackAnalyticsEvent(eventKey, attrs)
  } catch (error) {
    console.error('Analytics middleware error:', error);
  }

  return next(action);
};

export default analyticMiddleware;
